import React, { useEffect } from "react";
import PicturesUploadRequired from "./PicturesUploadRequired";
import { useUploadPicturesFollowUp } from "./hooks/UploadPictures";
import { useDispatch } from "react-redux";
import { addGtmPageView as pageview } from "redux/actions/gtmActions";
import CardDescription from "../../components/Cards/CardDescription";

const cardDescription = { type: "PICTURES_UPLOAD_REQUIRED" };
export const UploadPictures = () => {
  const {
    sendPictures,
    doneWithPictures,
    numberOfPictures,
    pictures
  } = useUploadPicturesFollowUp();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageview("PICTURES_UPLOAD_REQUIRED"));
  }, [dispatch]);

  return (
    <>
      <CardDescription {...cardDescription} />
      <PicturesUploadRequired
        sendPictures={sendPictures}
        doneWithPictures={doneWithPictures}
        numberOfPictures={numberOfPictures}
        pictures={pictures}
      />
    </>
  );
};

export default UploadPictures;
